///<amd-module name = "Core/Medius.Core.Web/Scripts/Medius/core/store/inbox/columnWidth"/>
import { createLocalStore } from "Core/Medius.Core.Web/Scripts/Medius/lib/store/async";

const prefix = "Core:inbox-column-width";

export const columnWidthStore = createLocalStore(prefix);